import EmptyResult from 'component/EmptyResult'
import ShortVideoBox from 'component/ShortVideoBox'
import { ShortWrap } from './Styled'
import { useImmer } from 'use-immer'
import { fetchShortHistoryList } from 'api'
import { useEffect, useMemo, useRef } from 'react'
import { InfiniteScrollCmsGridWrapper } from 'commonStyledComponents'
import { usePageActivated } from 'app-layered-layout/usePageActivated'

interface ShortState {
  nextPage: number
  isLoading: boolean
  hasMore: boolean
  list: any[]
  page_result: { current: number | null; pageSize: number | null; total: number | null }
  current?: number
}

const Short = () => {
  const [state, updateState] = useImmer<ShortState>({
    nextPage: 1,
    isLoading: true,
    hasMore: true,
    list: [],

    page_result: { current: null, pageSize: null, total: null },
  })

  const firstEnter = useRef(true)
  const pageActivated = usePageActivated()

  const handleFetchVideoList = async () => {
    if (state.current === state.page_result.current || !state.hasMore) return

    const data = {
      current: state.nextPage,
    }

    try {
      const response = await fetchShortHistoryList(data)
      firstEnter.current = false
      updateState((draft) => {
        draft.list = draft?.list?.concat(response?.data)
        draft.hasMore = response?.page_result?.total > response?.page_result?.current * response?.page_result?.pageSize
        draft.nextPage = response?.page_result?.current + 1
        draft.page_result = response.page_result

        draft.isLoading = false
      })
    } catch (error) {
      updateState((draft) => {
        draft.isLoading = false
      })
    }
  }

  const shortInfo = useMemo(
    () => ({
      list: state?.list ?? [],
      updateList: (reducer: (list: any[]) => any[]) => {
        updateState((draft) => {
          draft.list = reducer(draft.list)
        })
      },
    }),
    [state?.list, updateState]
  )

  useEffect(() => {
    if (pageActivated && !firstEnter.current) {
      updateState((draft) => {
        draft.nextPage = 1
        draft.isLoading = true
        draft.hasMore = true
        draft.list = []
        draft.page_result = { current: null, pageSize: null, total: null }
      })
    }
  }, [pageActivated, updateState])

  return !state?.list?.length && !state.isLoading ? (
    <EmptyResult />
  ) : (
    <ShortWrap>
      <InfiniteScrollCmsGridWrapper
        pageStart={0}
        loadMore={handleFetchVideoList}
        hasMore={state?.hasMore}
        // loader={<div className="loader" key={0}>Loading ...</div>}
        useWindow={false}
      >
        {state?.list?.map((item, i) => (
          <ShortVideoBox ey={i} videoInfo={item} columns={3} shortInfo={shortInfo} noTitle>
            {i}
          </ShortVideoBox>
        ))}
      </InfiniteScrollCmsGridWrapper>
    </ShortWrap>
  )
}

export default Short
